import { Box } from "@mui/material";
import Grid from "@mui/material/Grid2";
import Stages from "./Stages";
import { Board } from "../../../../types/board";
import { Dispatch, SetStateAction } from "react";
import {
  DragDropContext,
  Droppable,
  DropResult,
  DroppableProvided,
} from "@hello-pangea/dnd";
import { setNewBoard } from "../../../../redux/features/custom-board/custom-board-slice";
import { useDispatch } from "react-redux";
import React from "react";

interface StageComponentProps {
  newBoard: Board;
  setErrorMsg: Dispatch<SetStateAction<string>>;
  setError: Dispatch<SetStateAction<boolean>>;
}

const StageComponent: React.FC<StageComponentProps> = ({
  newBoard,
  setError,
  setErrorMsg,
}) => {
  const dispatch = useDispatch();

  const handleDragEnd = (result: DropResult) => {
    const { destination, source } = result;

    // If dropped outside the droppable area or in the same position
    if (
      !destination ||
      (destination.droppableId === source.droppableId &&
        destination.index === source.index)
    ) {
      return;
    }

    // Create a copy of the stages array
    const stages = [...newBoard.stages];

    // Remove the dragged item from its current position
    const [movedStage] = stages.splice(source.index, 1);

    // Insert the dragged item at the new position
    stages.splice(destination.index, 0, movedStage);

    // Update all indices to match the new positions
    const updatedStages = stages.map((stage, index) => ({
      ...stage,
      index,
    }));

    // Dispatch the updated stages array
    dispatch(setNewBoard({ name: "stages", value: updatedStages }));
  };
  // console.log(newBoard.stages, "newBoard.stages");

  return (
    <Grid>
      <Box className="stage">
        <DragDropContext onDragEnd={handleDragEnd}>
          <Droppable droppableId="stages-list">
            {(provided: DroppableProvided) => (
              <div {...provided.droppableProps} ref={provided.innerRef}>
                {newBoard.stages.map((stage, i) => (
                  <Stages
                    stage={stage}
                    setErrorMsg={setErrorMsg}
                    setError={setError}
                    primitive={newBoard.primitive ?? false}
                    key={stage.id + i} // Use only stage.id as key for better performance
                    stageName={stage.stageName}
                    stageId={stage.id}
                    stageIndex={i} // Use map index instead of stage.index for consistency
                    permission={newBoard.permission}
                    boardType={newBoard.boardType}
                  />
                ))}
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        </DragDropContext>
      </Box>
    </Grid>
  );
};

export default StageComponent;
